﻿import { View } from '@appstractdk/as-core';

const defaultOptions = {
	accordionFoldContainerSelector: '.accordion-fold-container',
	accordionFoldSelector: '.accordion-fold',
	accordionActiveClass: 'active',
	accordionLink: 'accordion-item-link'
}
class Accordion extends View {

	constructor(el, options) {
		super(el);
		this.options = options ? options : defaultOptions;
		const fold = this.el.querySelector(this.options.accordionFoldSelector);
		if (!fold) { return; }

		this.accordionButton = this.el.children[1];
		const isTimelineType = this.accordionButton.classList.contains(this.options.accordionLink);
		const minAccordionHeight = window.innerWidth < 768 ? 46 : 46;
		this.heightLimit = isTimelineType ? minAccordionHeight : 0;

		this.addListener('click', '.accordion-button', this.onAccordionToggle.bind(this));

		if (this.el.classList.contains("active")) {
			this.toggleAccordion(true);
		}
	}

	onAccordionToggle() {
		if (this.el.classList.contains("open")) {
			this.el.classList.remove("open");
			this.toggleAccordion(false);
		} else {
			this.toggleAccordion();
		}

	}

	toggleAccordion(open) {
		const accordionFoldContainer = this.el.querySelector(this.options.accordionFoldContainerSelector);
		let addedPaddingOnAccordionHeight;

		if (open === undefined || open) {
			const accordionHeight = [...this.el.querySelectorAll(this.options.accordionFoldSelector)].map(container => parseInt(container.offsetHeight)).reduce((total, amount) => total + amount);
			addedPaddingOnAccordionHeight = accordionHeight + 50;
		}

		if (open === undefined) {
			this.el.classList.toggle(this.options.accordionActiveClass);
		} else if (open) {
			this.el.classList.add(this.options.accordionActiveClass);
		} else {
			this.el.classList.remove(this.options.accordionActiveClass);
		}

		const isActive = this.el.classList.contains(this.options.accordionActiveClass);
		accordionFoldContainer.style.maxHeight = `${isActive ? addedPaddingOnAccordionHeight : this.heightLimit}px`;
	}


	exposeButton(height, limit) {
		if (height > limit) {
			this.accordionButton.classList.remove("hidden");
		}
	}

	static init(selector = '.accordion:not(.self-mount)', base = document, options = defaultOptions) {
		return [...base.querySelectorAll(selector)].map(node => new Accordion(node, options));
	}
}


export default Accordion;
